import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { SpecraDataTable } from '@mono/ui-components/captains';
import { SpecraBadge, SpecraButton, SpecraLink, SpecraText } from '@mono/ui-components/ensigns';
import { SpecraEntityCell, SpecraSectionHeader } from '@mono/ui-components/lieutenants';
import { Testids } from '@mono/ui-selectors';
import { renderRouterLink } from '../../../../lib/renderRouterLink';
import { mappingVariant } from '../../badgeVariants';
import { registryHref } from '../../registryHref';
import { companyLabel, mappingLabel, mappingNote, NOT_STATED, qualsText, vehicleLabel } from './model';
const muted = (text)=>/*#__PURE__*/ _jsx(SpecraText, {
        size: "body-ui",
        tone: "muted",
        children: text
    });
// specra-allow local-composite: the spec-mandated versions table (REG-19); binds AnchorEntryRow columns to SpecraDataTable
export function VersionsTable({ rows, selectedId, onSelect, onMap }) {
    return /*#__PURE__*/ _jsxs("section", {
        className: "space-y-3",
        children: [
            /*#__PURE__*/ _jsx(SpecraSectionHeader, {
                variant: "group",
                title: "Everyone's version, exactly as written",
                action: /*#__PURE__*/ _jsx(SpecraText, {
                    size: "meta",
                    tone: "muted",
                    children: "Titles, quals and clearance are kept as the source wrote them. Mappings are reviewed by a person."
                })
            }),
            /*#__PURE__*/ _jsx(SpecraDataTable, {
                rows: rows,
                rowKey: (r)=>r.entryId,
                caption: "Versions as written",
                getRowLabel: (r)=>`${companyLabel(r)} ${r.titleAsWritten}`,
                isRowSelected: (r)=>r.entryId === selectedId,
                onRowClick: (r)=>onSelect(r.entryId),
                rowTestId: Testids.registryLcatAnchor.versionsRow,
                emptyTitle: /*#__PURE__*/ _jsx("span", {
                    "data-testid": Testids.registryLcatAnchor.versionsEmpty,
                    children: "Nothing is mapped to this anchor yet."
                }),
                emptyAction: onMap && /*#__PURE__*/ _jsx(SpecraButton, {
                    variant: "secondary",
                    onClick: onMap,
                    children: "Map a labor category"
                }),
                columns: [
                    {
                        id: 'company',
                        header: 'Company',
                        cell: (r)=>r.companyIsOwn || !r.company?.id ? companyLabel(r) : /*#__PURE__*/ _jsx(SpecraLink, {
                                href: registryHref(r.company) ?? undefined,
                                renderLink: renderRouterLink,
                                onClick: (e)=>e.stopPropagation(),
                                children: companyLabel(r)
                            })
                    },
                    {
                        id: 'title',
                        header: 'Their title',
                        cell: (r)=>/*#__PURE__*/ _jsx(SpecraEntityCell, {
                                title: r.titleAsWritten,
                                description: /*#__PURE__*/ _jsxs(_Fragment, {
                                    children: [
                                        "v",
                                        r.version,
                                        r.stale && /*#__PURE__*/ _jsxs(SpecraBadge, {
                                            variant: "warning",
                                            className: "ml-2",
                                            children: [
                                                "mapped at v",
                                                r.mappedVersion
                                            ]
                                        })
                                    ]
                                })
                            })
                    },
                    {
                        id: 'vehicle',
                        header: 'Vehicle',
                        cell: (r)=>vehicleLabel(r)
                    },
                    {
                        id: 'quals',
                        header: 'Quals',
                        cell: (r)=>qualsText(r) ?? muted(NOT_STATED)
                    },
                    {
                        id: 'clearance',
                        header: 'Clearance',
                        cell: (r)=>r.clearance || muted(NOT_STATED)
                    },
                    {
                        id: 'mapping',
                        header: 'Mapping',
                        cell: (r)=>/*#__PURE__*/ _jsx(SpecraEntityCell, {
                                title: /*#__PURE__*/ _jsx(SpecraBadge, {
                                    variant: mappingVariant(r.mappingStatus, r.relation),
                                    children: mappingLabel(r.mappingStatus, r.relation)
                                }),
                                description: mappingNote(r)
                            })
                    }
                ]
            })
        ]
    });
}
